const theme = {
  '--gray-color': '#2b2b2bff',
  '--orange-color': '#101827ff',
  '--orange-hover-color': '#353535ff',
  '--orange-datepicker-selection-color': 'rgba(235, 90, 59, 0.6)',
  '--blue-color': '#101827ff',
  '--white-color': '#353535ff',
  '--black-color': '#FFFFFF',
  '--navtext-color': '#FFFFFF',
  '--header-color': '#101827ff'
};

export default theme;